// extracted by mini-css-extract-plugin
export default {"wraper":"tab_wraper__KUWyA","items":"tab_items__wF6HV","scrollDiv":"tab_scrollDiv__YcvVQ","innerScrollDiv":"tab_innerScrollDiv__I6B8e"};